import { render, staticRenderFns } from "./HerbComparisonChart.vue?vue&type=template&id=02f86f33&scoped=true"
import script from "./HerbComparisonChart.vue?vue&type=script&lang=js"
export * from "./HerbComparisonChart.vue?vue&type=script&lang=js"
import style0 from "./HerbComparisonChart.vue?vue&type=style&index=0&id=02f86f33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f86f33",
  null
  
)

export default component.exports